import React from "react";
import styles from "./ownerVerifiedBadge.module.scss";
import icons from "../../assets/images/icons";

/**
 * 소유자 인증 뱃지 — 그라디언트 스타일
 *
 * 매물 관리 카드뷰, 매물 탐색(데스크톱), 채팅 카드 등에서 사용.
 * 체크 아이콘 + "소유자 인증" 그라디언트 텍스트.
 */
export function OwnerVerifiedGradientBadge() {
  return (
    <span className={styles.gradientBadge}>
      <img src={icons.ownerVerification.badge} alt="인증" className={styles.gradientIcon} />
      <span className={styles.gradientText}>소유자 인증</span>
    </span>
  );
}

/**
 * 소유자 인증 태그 — 해시태그 스타일
 *
 * 모바일 매물탐색, 로비, 타임라인 등에서 사용.
 * "#소유자 인증" + 빨간 하이라이트 데코레이션.
 */
export function OwnerVerifiedHashTag() {
  return (
    <span className={styles.hashTag}>#소유자 인증</span>
  );
}
